
<template>
  <v-card outlined style="border-radius:12px">
    <!-- <v-card-title secondary-title> -->
    <!-- <div class="subtitle-1 mb-0">Item</div> -->
    <!-- </v-card-title> -->
    <v-card-text>
      <v-col class="py-1 mb-2" style="border-radius: 12px; border-left: solid 1px #ddd" v-if="!is_flow">
        <div class="caption">
          Título
        </div>
        <div class="subtitle-1">
          <b>
            {{newItem.title}}
          </b>
        </div>
      </v-col>
      <v-col class="py-1 mb-2" style="border-radius: 12px; border-left: solid 1px #ddd" v-if="!is_flow">
        <div class="caption">
          Descrição
        </div>
        <div class="subtitle-1 use_enter mt-n5">
          <b>
            {{newItem.sentence}}
          </b>
        </div>
      </v-col>
      <!-- <v-text-field v-model="newItem.description" prepend-icon="mdi-search" label="label"></v-text-field> -->
      <!-- <v-select :items="allSolutions" item-text="name" item-value="id" v-model="newItem.solution_id" label="Solução" ></v-select> -->
      <!-- <v-select :items="allDepartments" item-text="name" item-value="id" v-model="newItem.department_id" label="Departamento" ></v-select> -->

      <template v-if="!is_compliance">
        <!-- <v-sheet class="ml-0" max-width="1000"> -->
        <v-row class="mx-2" align="center">
          <v-icon :color="'secondary'">mdi-circle-small</v-icon>
          <div>Tipo de Resposta:  </div>
          <v-slide-group style="overflow-x: auto" v-model="newItem.kind" center-active mandatory>
              <v-slide-item
                :value="kind.kind"
                v-for="(kind,idx) in active_solution_settings.item_kinds.filter(k=> k.kind == newItem.kind)"
                :key="'ckind2'+idx"
                v-slot:default="{ active, toggle }"
              >
                <v-btn
                  class="ml-2"
                  depressed
                  rounded
                  small
                  :input-value="true"
                  active-class="secondary darken-1 white--text"
                >
                  <v-icon left>{{kind.icon}}</v-icon>
                  {{kind.name}}
                </v-btn>
              </v-slide-item>

          </v-slide-group>
        </v-row>
        <!-- </v-sheet> -->
      </template>

      <!-- <component :is="setupComponent(newItem.kind)" :newItem.sync="newItem"></component> -->

      <!-- <template v-if="active_solution_settings.notification.includes('email')">
        <notification-email :newItem.sync="newItem"></notification-email>
      </template>-->

      <template v-if="['rating', 'react'].includes(newItem.kind)">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Mínimo:
            <div class="ml-2" v-if="['rating'].includes(newItem.kind)">
              <v-icon color="secondary" >{{`mdi-numeric-${newItem.minimum}-circle-outline`}}</v-icon>
              <v-icon color="secondary">mdi-star</v-icon>
            </div>
            <div class="ml-2" v-if="['react'].includes(newItem.kind)">
              <v-icon :color="face_map[newItem.minimum].color"> {{`mdi-numeric-${newItem.minimum}-circle-outline`}} </v-icon>
              <v-icon :color="face_map[newItem.minimum].color"> {{face_map[newItem.minimum].icon}} </v-icon>
            </div>
          </v-row>
        </div>
        <!-- <custom-weight :newItem.sync="newItem"></custom-weight> -->
      </template>

      <template v-if="['checklist', 'options'].includes(newItem.kind)">
        <div class="ma-2">
          <v-icon :color="'secondary'">mdi-circle-small</v-icon>
          Opções:
          <v-col v-for="(sub, idx) in newItem.sub_items" :key="sub.name" :class="['pa-1', sub.is_minimum? 'secondary--text' : '']">
            <v-icon small class="ml-3" :color="sub.is_minimum? 'secondary' : ''">mdi-chevron-right</v-icon> <b> {{sub.name}} </b> <span class="caption"> {{sub.is_minimum? '(resp. desejada)' : ''}} </span>
          </v-col>
        </div>
        <!-- <custom-weight :newItem.sync="newItem"></custom-weight> -->
      </template>

      <template v-if="['input'].includes(newItem.kind)">
        <v-row class="mx-2">
          <v-icon :color="'secondary'">mdi-circle-small</v-icon>
          <div>
            Tipo: <span class="ml-2 subtitle-2"> <b> {{newItem.input_kind == 'text'? 'Texto' : 'Número'}} </b> </span>
          </div>
        </v-row>
        <v-row class="mx-2" v-if="newItem.input_kind == 'number'">
          <v-icon :color="'secondary'">mdi-circle-small</v-icon>
          <div>
            Limites: 
            <span class="ml-2 mr-3 subtitle-2"> Mín.: <b> {{newItem.has_minimum? newItem.minimum : '-'}} <v-icon v-if="!newItem.has_minimum" class="pb-1">mdi-infinity</v-icon> </b> </span>
            <span class="ml-2 mr-3 subtitle-2"> Máx.: <b> {{newItem.has_maximum? newItem.maximum : '+'}} <v-icon v-if="!newItem.has_maximum" class="pb-1">mdi-infinity</v-icon> </b> </span>
          </div>
        </v-row>
        <!-- <custom-weight :newItem.sync="newItem"></custom-weight> -->
      </template>

      <template v-if="uses_weight">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Peso:
            <v-btn icon small depressed :input-value="true" class="ml-2" active-class="secondary--text" >
              <v-icon >{{`mdi-numeric-${newItem.weight}-circle-outline`}}</v-icon>
            </v-btn>
          </v-row>
        </div>
        <!-- <custom-weight :newItem.sync="newItem"></custom-weight> -->
      </template>

      <template v-if="uses_not_apply">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Exibir opção de não se aplica (NA):
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.not_applied_enabled? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.not_applied_enabled? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
      </template>

      <template v-if="uses_photos">
        <!-- melhorar, tem outras tipos ↓ de foto (0,1,2) -->
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Necessário foto?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" v-if="photo_map[newItem.photo]">
              <v-icon left>{{ photo_map[newItem.photo].icon }}</v-icon>{{ photo_map[newItem.photo].text }}
            </v-btn>
          </v-row>
        </div>
        <!-- <allowed-photo :newItem.sync="newItem"></allowed-photo> -->
      </template>

      <template v-if="active_solution_settings.allowed_comment && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Necessidade de comentário
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.needs_comment? 'mdi-close-outline' : 'mdi-selection-ellipse-arrow-inside'}}</v-icon>{{newItem.needs_comment? 'Obrigatório para inconformidades' : 'Sempre opcionais'}}
            </v-btn>
          </v-row>
        </div>
        <!-- <allowed-comment :newItem.sync="newItem"></allowed-comment> -->
      </template>

      <template v-if="is_flow && uses_comment_kind">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Tipo de comentário
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" v-if="comment_map[newItem.comment_kind]">
              <v-icon left>{{ comment_map[newItem.comment_kind].icon }}</v-icon>{{ comment_map[newItem.comment_kind].text }}
            </v-btn>
          </v-row>
        </div>
        <!-- <allowed-comment :newItem.sync="newItem"></allowed-comment> -->
      </template>

      <template v-if="active_solution_settings.can_use_repeat && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Pode ser repetido durante execução?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.can_be_repeated? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.can_be_repeated? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
      </template>

      <template v-if="active_solution_settings.risk_item && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Item de risco?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.is_risk? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.is_risk? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
        <!-- <risk-item :newItem.sync="newItem"></risk-item> -->
      </template>
      <template v-if="active_solution_settings.block_execution_if_not_succeeded && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Bloquear execução quando inconforme?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.block_execution_if_not_succeeded? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.block_execution_if_not_succeeded? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
        <!-- <risk-item :newItem.sync="newItem"></risk-item> -->
      </template>

      <template v-if="active_solution_settings.custom_answer_validation && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Validação customizada?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.has_custom_validation? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.has_custom_validation? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
        <!-- <custom-validation :newItem.sync="newItem"></custom-validation> -->
      </template>

      <template v-if="(active_solution_settings.action_plan || (active_solution_settings.action_plan_on_risk && newItem.is_risk)) && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Plano de ação para inconformes?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.action_plan_enabled? 'mdi-check' : 'mdi-close'}}</v-icon>{{newItem.action_plan_enabled? 'Sim' : 'Não'}}
            </v-btn>
          </v-row>
        </div>
        <!-- <action-plan :newItem.sync="newItem"></action-plan> -->
      </template>

      <template v-if="active_solution_settings.use_form_email_settings && newItem.send_email_depending_on_answer && !is_flow">
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Enviar email com condicional de resposta?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text" >
              <v-icon left>{{newItem.send_email_depending_on_answer? 'mdi-check-all' : 'mdi-close'}}</v-icon>
              {{newItem.send_email_depending_on_answer? 
                `Sim. Quando ${newItem.send_email_when_answer_is == 'succeeded'? 'a resposta estiver conforme' : 'houver inconformidades'}` 
                : 'Não'
              }}
            </v-btn>
          </v-row>
        </div>
        <!-- <action-plan :newItem.sync="newItem"></action-plan> -->
      </template>

      <template v-if="uses_qrcode_verification">
        <!-- melhorar, tem outras tipos ↓ de foto (0,1,2) -->
        <div class="my-2">
          <v-row class="mx-2" align="center">
            <v-icon :color="'secondary'">mdi-circle-small</v-icon>
            Necessária a validação por QrCode?
            <v-btn class="mx-2" text rounded x-small :input-value="true"  active-class="secondary--text">
              <v-icon left>{{ newItem.needs_verification_by_qr_code? 'mdi-check' : 'mdi-close' }}</v-icon>
              {{ newItem.needs_verification_by_qr_code? 'Sim' : 'Não' }}
            </v-btn>
          </v-row>
        </div>
        <!-- <allowed-photo :newItem.sync="newItem"></allowed-photo> -->
      </template>

    </v-card-text>
    <v-card-actions class="justify-end" v-if="false">
      <v-btn text color="error">Cancelar</v-btn>
      <v-btn text color="secondary">OK</v-btn>
    </v-card-actions>

    <dialog-loading v-if="loading"></dialog-loading>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    newItem: {
      type: Object
      // default:
    },
    is_flow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // NotificationEmail: () => import('./shared/NotificationEmail.vue'),
    CustomWeight: () => import('./shared/ItemWeight.vue'),
    NotApplied: () => import('./shared/NotApplied.vue'),
    AllowedPhoto: () => import('./shared/AllowedPhotos.vue'),
    AllowedComment: () => import('./shared/AllowedComment.vue'),
    RiskItem: () => import('./shared/RiskItem.vue'),
    ActionPlan: () => import('./shared/ActionPlan.vue'),
    CustomValidation: () => import('./shared/CustomAnswerValidation.vue'),
  },
  data() {
    return {
      SetupRating: () => import("./shared/SetupRating.vue"),
      SetupReact: () => import("./shared/SetupReact.vue"),
      SetupInput: () => import("./shared/SetupInput.vue"),
      SetupOptions: () => import("./shared/SetupOptions.vue"),
      SetupChecklist: () => import("./shared/SetupChecklist.vue"),
      SetupSignature: () => import("./shared/SetupSignature.vue"),
      SetupCustomField: () => import("./shared/SetupCustomField.vue"),

      loading: false,
      loadingText: null,
      
      photo_map: {
        '0': {
          text: 'Não',
          icon: 'mdi-close',
        },
        '1': {
          text: 'Apenas para inconformidades',
          icon: 'mdi-check',
        },
        '2': {
          text: 'Sim, sempre',
          icon: 'mdi-check-all',
        },
        '3': {
          text: 'Sim, opcional',
          icon: 'mdi-check-outline',
        },
      },

      comment_map: {
        'false': {
          text: 'Não',
          icon: 'mdi-close',
        },
        'true': {
          text: 'Apenas para inconformidades',
          icon: 'mdi-check',
        },
        'required_not_ok': {
          text: 'Sim, sempre',
          icon:'mdi-close-outline',
        },
        'required_ok': {
          text: 'Sim, opcional',
          icon:'mdi-check-outline',
        },
        'optional': {
          text: 'Sim, opcional',
          icon:'mdi-dots-circle',
        },
      },

      face_map: {
        '1': {value: '1', color: 'error', icon:'mdi-emoticon-frown-outline'},
        '2': {value: '2', color: 'red', icon:'mdi-emoticon-sad-outline'},
        '3': {value: '3', color: 'amber', icon:'mdi-emoticon-neutral-outline'},
        '4': {value: '4', color: 'secondary', icon:'mdi-emoticon-outline'},
        '5': {value: '5', color: 'success', icon:'mdi-emoticon-excited-outline'},
      },

      allKinds: [
        {
          name: "Sim ou Não",
          kind: "thumb",
          icon: "mdi-thumbs-up-down",
          creating_component: null
        },
        {
          name: "Pontuação",
          kind: "rating",
          icon: "mdi-star-outline",
          creating_component: "SetupRating"
        },
        {
          name: "Reações",
          kind: "react",
          icon: "mdi-emoticon-outline",
          creating_component: "SetupReact"
        },
        {
          name: "Valor",
          kind: "input",
          icon: "mdi-textbox",
          creating_component: "SetupInput"
        },
        {
          name: "Opções",
          kind: "options",
          icon: "mdi-checkbox-marked-circle-outline",
          creating_component: "SetupOptions"
        },
        {
          name: "Seleções",
          kind: "checklist",
          icon: "mdi-checkbox-marked-outline",
          creating_component: "SetupChecklist"
        }
      ]
    };
  },
  methods: {
    setupComponent(kind) {
      if (kind) {
        let b = this.active_solution_settings.item_kinds.find(
          o => o.kind == kind
        )
        b = b? b.creating_component : b;
        // let b = this.allKinds.find(o=>o.kind == kind).creating_component
        //    // auto-comment// console.log({b});
        //    // auto-comment// console.log(this[b]);

        return b? this[b] : null;
      }
    },
    ...mapActions({
      indexUser: "User/index"
      // function: 'Module/action'
    })
  },
  computed: {
    is_compliance() {
      return (
        false &&
        this.allSolutions.find(obj => obj.id == this.solutionID).proposal_name == "compliance"
      );
    },
    flow_config(){
      if (this.is_flow && this.one_flow) {
        return this.one_flow.json_attributes
      }
      return null
    },
    uses_weight(){
      if (this.is_flow){
        const {uses_weight} = this.flow_config.step_item_config
        return uses_weight
      } else {
        return true || this.active_solution_settings.allowed_custom_weight
      }
    },
    uses_not_apply(){
      if (this.is_flow){
        const {uses_not_apply} = this.flow_config.step_item_config
        return uses_not_apply
      } else {
        return true || this.active_solution_settings.allowed_not_applied
      }
    },
    uses_sentence_img(){
      if (this.is_flow){
        const {uses_img_sentece} = this.flow_config.step_item_config
        return uses_img_sentece
      } else {
        return true || this.active_solution_settings.allow_sentence_img
      }
    },
    uses_photos(){
      if (this.is_flow){
        const {photos} = this.flow_config.step_item_config
        return photos.length>0
      } else {
        return true || this.active_solution_settings.allowed_photos
      }
    },
    uses_comment(){
      if (this.is_flow){
        const {uses_comment} = this.flow_config.step_item_config
        return false
      } else {
        return true || this.active_solution_settings.allowed_comment
      }
    },
    uses_comment_kind(){
      if (this.is_flow){
        const {uses_comment} = this.flow_config.step_item_config
        return uses_comment
      } else {
        return false
      }
    },
    uses_qrcode_verification(){
      return this.active_solution_settings.allow_verification_by_qr_code
      if (this.is_flow){
        const {photos} = this.flow_config.step_item_config
        return photos.length>0
      } else {
      }
    },
    active_solution_settings() {
      if (this.solutionID) {
        return this.allSolutions.find(o => o.id == Number(this.solutionID)).settings;
      }
    },
    ...mapState({
      // newItem: state=> state.Form.newItem,
      allUsers: state => state.User.allUsers,
      allSolutions: state => state.Solution.allSolutions,
      solutionID: state => state.Solution.solutionID,
      one_flow: state => state.ConfigFlow.one_flow,
    })
  },
  mounted() {
    if (this.is_compliance) {
      this.newItem.kind = "thumb";
    }
  },
  watch: {
    solutionID(nv,ov) {
      if (nv){
        this.newItem.has_minimum = false
        this.newItem.minimum = null
        this.newItem.input_kind = null
      } else if (nv == false){
    
      }
    },
    allUsers(nv, ov) {
      if (nv) {
      } else if (nv == false) {
      }
    }
  }
};
</script>

<style scoped>
.v-slide-group__next,
.v-slide-group__prev {
  min-width: 20px !important;
}

.use_enter {
  white-space: pre-line; /* or pre-line */
}
</style>